// Généré automatiquement : textes français traduisibles de l'interface et du devis
export const UI_KEYS = [
"1 essieu",
"1 place",
"1,5 place",
"2 essieux",
"2 places diagonale",
"2 places droit",
"3 places diagonale",
"4 places diagonale",
"Accès revendeurs & administrateurs",
"Acompte",
"Acompte (35%)",
"Acompte payé par",
"Actions",
"Adresse",
"Affiche créée et enregistrée dans Véhicules à la vente",
"Affiche mise à jour",
"Afficher :",
"Afficher le mot de passe",
"Afficher mon numéro de téléphone sur l'affiche",
"Aide client TTC",
"Aide totale client",
"Ajouter",
"Ajouter une photo",
"Ajouter une pièce jointe",
"Ajouter une reprise",
"Ajoutez une photo du véhicule repris.",
"Allemagne",
"Alu",
"Annuler",
"Année",
"Antivol intégré",
"Appelez-moi au",
"Appliquer la promotion :",
"Arches",
"Attelage",
"Attention",
"Aucun devis pour le moment",
"Aucun modèle disponible dans cette catégorie.",
"Aucun texte traduisible trouvé ici",
"Aucun van d'occasion en stock",
"Aucun véhicule en stock pour le moment.",
"Aucune description pour le moment.",
"Aucune occasion en stock",
"Aucune option renseignée",
"Aucune option spéciale.",
"Aucune photo de la reprise",
"Aucune version disponible.",
"Australie",
"Autre",
"Autre (précisez)",
"Autre couleur RAL",
"Autre, préciser",
"Autre…",
"Autriche",
"BON POUR ACCORD",
"Bande du bas",
"Bande du bas d'une couleur différente",
"Bandes déco",
"Beige gris",
"Belgique",
"Besoin d'un accès revendeur ? Contactez votre administrateur Fautras.",
"Blanc",
"Bleu pastel",
"Bois",
"Bon pour accord",
"Bon état",
"CB",
"CLIENT",
"COMMANDE",
"Carte bancaire",
"Catégories :",
"Cette action est définitive.",
"Changer la photo",
"Chevaux islandais",
"Chevaux standard",
"Chez",
"Choisir dans la liste",
"Choisir le lieu de livraison",
"Choisir mon mot de passe",
"Choisir un fichier RIB",
"Choisir un modèle",
"Choisir…",
"Choisissez votre modèle",
"Choisissez votre version",
"Chèque",
"Client",
"Code postal",
"Combien de chevaux souhaitez-vous transporter ?",
"Commande signée",
"Comparer avec un autre modèle",
"Configurateur",
"Configurateur de devis revendeurs",
"Confirmer le mot de passe",
"Connexion",
"Connexion réussie",
"Continuer",
"Continuer sans photo",
"Coordonnées bancaires affichées dans l'e-mail",
"Coordonnées client",
"Corriger la traduction",
"Corée du Sud",
"Couleur",
"Couleur des arches avant",
"Couleur des bandes déco",
"Couleur à choisir avant de passer commande",
"Couleurs disponibles",
"Couleurs spéciales · en option",
"Couleurs standards · sans surcoût",
"Coût de revient HT",
"Coût rev. HT",
"Coût revendeur HT",
"Créer l'affiche",
"Créer l'affiche de prix et mettre en stock",
"Créer une affiche prix",
"DEVIS",
"Date",
"Descriptif",
"Description",
"Devis valable jusqu'au",
"Divers",
"Dupliquer",
"DÉLAI IMPÉRATIF",
"DÉTAIL DE LA REPRISE",
"Déconnexion",
"Délai : confirmé à réception de commande par Fautras",
"Délai impératif",
"Délai souhaité par le client",
"Désignation",
"Détails de l'option sur-mesure…",
"Détails du modèle",
"E-mail du client",
"EQUIPEMENTS DE SERIE",
"Email",
"Email (pour l'envoi du devis)",
"Email ou mot de passe incorrect",
"En bon état",
"En stock à",
"Enregistrer",
"Enregistrer + Envoyer",
"Enregistrer + PDF",
"Enregistrer comme mon RIB par d\\u00e9faut",
"Enregistrer mon mot de passe",
"Envoyer",
"Envoyer le devis par e-mail",
"Envoyer par e-mail au client",
"Espagne",
"Ex. : livraison avec plein d'eau, rendez-vous à confirmer…",
"Ex. Habillage spécifique",
"Ex. RAL 5015 bleu ciel",
"Ex. Salon du cheval d'Angers 2026",
"F2 (PTAC)",
"Faisceau et feu(x) à réparer/remplacer",
"Fermer",
"Feu(x) à réparer/remplacer",
"Feux et électricité",
"Fichier choisi",
"Finaliser le devis",
"Financement",
"France",
"Freins",
"Garantie",
"Garantie structure Fautras jusqu'en",
"Garde-boue",
"Gris anthracite",
"Gris jaune",
"Gris perle",
"Gris souris",
"HT",
"Immat.",
"Immatriculation",
"Importer une reprise d'un véhicule d'occasion",
"Imprimer",
"Inclus",
"Indiquez votre e-mail : vous recevrez un lien pour choisir votre mot de passe.",
"Infos option",
"Irlande",
"Italie",
"J'ai lu et j'accepte les conditions générales de vente",
"Jaune citron",
"Joindre un RIB",
"Joindre un autre RIB",
"La configuration (modèle, options, promo) est enregistrée dans « Véhicules à la vente » et l'affiche A4 s'affiche pour contrôle.",
"Le mot de passe doit contenir au moins 8 caractères",
"Le prix public inclut la livraison au revendeur le plus proche dans le pays sélectionné.",
"Le prix public inclut le transport usine → revendeur ; prix revendeur hors transport.",
"Le saviez-vous",
"Les deux mots de passe ne sont pas identiques",
"Les mêmes options sélectionnées sont appliquées au modèle comparé (prix TTC).",
"Libellé",
"Lien déjà utilisé.",
"Lien incomplet. Refaites une demande depuis la page de connexion.",
"Lien invalide ou expiré. Refaites une demande de mot de passe.",
"Lieu de livraison",
"Tous les pays",

"Lieu de stockage",
"Choisir le lieu de stockage",
"Préciser le lieu",
"Copier le lien vers le devis",
"Frais d'immatriculation",
"Carte grise",
"Frais de plaque",
"Frais administratifs",
"sans TVA",
"Total à payer TTC",
"TOTAL A PAYER TTC",
"Affichage indicatif en euros : le devis et le PDF restent en",
"Emails à vérifier",
"Email refusé : à vérifier",
"Adresse refusée par le service d'envoi",
"Enregistrer l'adresse corrigée",
"Adresse email du client corrigée",
"Copier le lien",
"Lien du devis copié : collez-le dans votre message au client",
"Impossible de copier le lien",
"Origine du véhicule enregistrée. Copier le lien de signature du devis ?",
"Continuer vers la signature",

"Lieu de stockage / événement :",
"Lieux de stockage",
"Luxembourg",
"Maintenir pour afficher marge / coût revendeur",
"Marge HT",
"Marge estimée HT",
"Marge revendeur HT",
"Marque",
"Masquer le mot de passe",
"Mauvais état",
"Mes devis",
"Mes options",
"Mes reprises",
"Mettre en stock et créer une affiche prix",
"Mettre en stock occasion",
"Mettre en stock un van d'occasion",
"Mettre en stock une occasion",
"Mettre à jour l'affiche",
"Mode traduction : cliquez sur un texte pour le corriger",
"Modifier",
"Modifier le devis",
"Modifier les coordonnées client",
"Modèle",
"Modèle à comparer :",
"Modèles",
"Mon RIB enregistr\\u00e9",
"Mot de passe",
"Mot de passe enregistré. Vous pouvez vous connecter.",
"Mot de passe oublié",
"Mot de passe oublié ?",
"NET A PAYER TTC",
"Nbre de places",
"Net à payer HT",
"Net à payer TTC",
"Neuf",
"Neuf et occasion",
"Nom",
"Nous pouvons racheter votre ancien van.",
"Nous pouvons racheter votre ancienne remorque.",
"Nouveau mot de passe (8 caractères minimum)",
"Nouvelle occasion",
"Nouvelle-Calédonie",
"OCCASION",
"OFFERT",
"OPTIONS DU MODELE EXPOSE",
"OPTIONS ET EQUIPEMENTS",
"OPTIONS SPÉCIALES",
"Occasion",
"Offre valable jusqu'au",
"Options",
"Options TTC",
"Options ajoutées",
"Options ajoutées au modèle comparé :",
"Options en texte libre",
"Options et équipements",
"Options spéciales",
"Options spéciales TTC",
"Options sur-mesure avec description et pièce jointe (croquis…).",
"Orange pur",
"Ouvrir dans le configurateur",
"PDF de la commande signée introuvable",
"PRIX DU MODELE EXPOSE",
"PRIX DU MODELE HORS OPTION",
"PRIX DU VEHICULE",
"PRÉCISIONS",
"Pas encore de prix public hors France pour cette gamme",
"Pas encore de prix public hors France pour cette gamme : les prix France sont utilisés.",
"Pas encore de tarif pour ce pays (prix France)",
"Pas encore de tarif pour ce pays : prix France affichés",
"Pays",
"Pays de livraison",
"Pays-Bas",
"Photo d'origine",
"Photo du modèle à titre indicatif (peut comporter des options payantes).",
"Photos jointes",
"Pièce jointe ajoutée",
"Places",
"Plancher",
"Plancher imputrescible garantie à vie",
"Pneus",
"Pologne",
"Polyester",
"Polyéthylène",
"Pont / portes / ouvertures",
"Portugal",
"Pour mettre un véhicule en stock, configurez un modèle dans le",
"Prix HT",
"Prix TTC",
"Prix TTC (€)",
"Prix avant aide TTC",
"Prix avant remise TTC",
"Prix de reprise HT",
"Prix de reprise TTC",
"Prix du modèle",
"Prix du modèle TTC",
"Prix du modèle après aide",
"Prix du modèle après remise",
"Prix en",
"Prix hors transport usine → revendeur",
"Prix hors transport usine → revendeur.",
"Prix public",
"Prix public HT",
"Prix public TTC",
"Prix remisé TTC",
"Prix revendeur",
"Prix revendeur HT",
"Prix revendeur hors transport",
"Prix revendeur hors transport.",
"Prix stock",
"Prix unitaire :",
"Promo",
"Promo options non applicable",
"Promotion",
"Promotion appliquée",
"Prix en bleu et en gras : prix remisés par la promotion",

"Promotions",
"Promotions / remises salon :",
"Préciser le lieu de livraison",
"Précisez :",
"Précisez la marque",
"Précisions (imprimées sur le devis et la commande)",
"Prénom",
"Préparation du PDF…",
"Préparation du devis…",
"Public",
"Quelle longueur de chargement vous faut-il ?",
"REVENDEUR",
"Recadrer",
"Recevoir le lien",
"Rechercher…",
"Remettre en stock",
"Remise %",
"Remise client TTC",
"Remise revendeur",
"Remise totale client",
"Remorque fourgon",
"Remorques fourgon Pro & Sport",
"Remplacer la pièce jointe",
"Renseignez les informations du client pour générer le devis en PDF ou l'envoyer par email.",
"Renseignez les informations du client, ou laissez vide et continuez directement vers le choix du modèle.",
"Reprise",
"Reprise (€ HT)",
"Reprise (€ TTC)",
"Reprise d'un véhicule d'occasion",
"Estimer la reprise",
"Ajouter une option spéciale",
"Cliquez sur « Estimer la reprise » : les informations du véhicule et le prix de reprise sont remplis par l'estimateur.",
"Total après remise HT",
"Total après remise TTC",
"Total après aide HT",
"Total après aide TTC",
"Total avec frais d'immatriculation HT",
"Total avec frais d'immatriculation TTC",
"Total à payer HT",
"Frais administratifs et de plaque",
"Frais administratifs et de plaque TTC",
"Frais administratifs (prix revendeur)",
"Frais administratifs (prix public)",
"Total frais d'immatriculation",
"Veuillez renseigner une description pour chaque option spéciale.",
"Prix de reprise proposé par le vendeur",
"Estimation Horse Trailer Price",
"Reprise TTC",
"Reprise HT",
"Prix revendeur TTC",
"Prix client TTC",
"Prix proposé par le vendeur",
"Aucun montant transmis",
"Reprise remplie depuis Horse Trailer Price",
"Choisissez le type van ou fourgon pour estimer la reprise.",
"Fenêtre bloquée : autorisez les fenêtres pop-up pour ce site.",
"Impossible d'ouvrir Horse Trailer Price.",
"Connexion à Horse Trailer Price non configurée (secret manquant).",
"Essieux",
"1 essieu",
"2 essieux",
"Refait à neuf",
"Longueur intérieure (cm)",
"Largeur intérieure (cm)",
"Hauteur intérieure (cm)",
"Grands chevaux",
"Flèche calèche",
"Ouverture estivale",
"Sortie avant",
"Toit",
"Échelle + galerie",
"Jantes alu",

"Reprise occasion",
"Retirer",
"Retour",
"Retour au configurateur",
"Retour aux schémas",
"Retour à la connexion",
"Revendeur",
"Revendeur du secteur",
"Revendeurs ayant accès (aucun coché = tous)",
"Rose",
"Roue de secours",
"Équipements de série",
"Rouge framboise",
"Royaume-Uni",
"Récapitulatif du devis",
"Réimprimer l'affiche",
"République Tchèque",
"Réservé à",
"Révisé et en bon état",
"Sans TVA",
"Se connecter",
"Si un compte existe pour cette adresse, un e-mail vient de vous être envoyé avec un lien pour choisir votre mot de passe (valable 1 heure). Pensez à regarder dans vos courriers indésirables.",
"Signature client — page",
"Signature du client — Bon pour accord",
"Signer",
"Signer et passer commande",
"Slovénie",
"Société",
"Solde a la livraison",
"Solde payé par",
"Solde à la livraison",
"Sous-total avant aide",
"Sous-total avant remise",
"Statut",
"Stock disponible",
"Structure et châssis",
"Structure garantie 8 ans",
"Structure garantie 8 ans (avec arceau de sécurité)",
"à",
"Suisse",
"Supprimer",
"Supprimer la reprise",
"Suède",
"Sélectionnez un modèle",
"Sélectionnez un modèle pour voir la comparaison.",
"TOTAL TTC",
"TRANSPORT DIAGONAL",
"TRANSPORT DROIT",
"TTC",
"TVA",
"TVA non applicable",
"TVA récupérable",
"TVA récupérable (20 %)",
"Tapis",
"Tarifs",
"Tarifs :",
"Tarifs publics",
"Tarifs revendeur",
"Tarifs revendeur & public",
"Tarifs revendeur et public",
"Terminer",
"Texte français d'origine, puis traduction affichée",
"Titulaire du compte",
"Total HT",
"Total TTC",
"Total après aide",
"Total après remise",
"Total options après aide",
"Total options après remise",
"Tous",
"Tous les statuts",
"Tous les vendeurs",
"Mes devis uniquement",
"Bon de commande papier signé",
"Bon de commande papier signé par le client",
"Signé sur bon de commande papier (copie en dernières pages)",
"Signature sur l'écran",
"Ajouter une photo",
"Enregistrer la commande papier",
"Enregistrement de la commande papier…",
"Prenez en photo chaque page du bon de commande papier signé par le client (ou ajoutez le PDF scanné).",
"La commande et les photos seront envoyées à vous, à Corinne Golfier et à contact@fautras.com. Le client ne reçoit pas d'e-mail.",
"Commande papier envoyée à vous et à contact@fautras.com (pas au client). Corinne la recevra une fois l'acompte reçu et le financement choisi.",
"La commande et les photos seront envoyées à vous et à contact@fautras.com ; Corinne Golfier la recevra une fois l'acompte reçu et le financement choisi. Le client ne reçoit pas d'e-mail.",
"Envoi de la photo impossible",
"Bon papier",
"Photo",
"Fichier introuvable",
"Signée du",
"Signée le",
"Effacer",
"Commandes secteur",
"Commandes hors secteur",
"Commande hors secteur",
"Commande secteur",
"Corriger la commande (revendeur, acompte)",
"Coordonnées client et précisions ADV",
"Client / précisions",

"Commande hors secteur : validation manager",
"Responsable du secteur",
"Traitée par l'ADV",
"Traitées par l'ADV",
"Commande marquée traitée par l'ADV",
"Commande remise à traiter",
"ADV",
"Voir le PDF de la commande",
"Impossible de charger les commandes",
"Commandes à traiter",
"Commandes sans numéro cde Divalto",
"Sans numéro cde Divalto",
"Hors secteur",
"À traiter",
"Toutes les commandes",
"Exporter (Excel)",
"Exporter les commandes (Excel)",
"Accès réservé à l'ADV",
"Aucune commande à afficher",
"Acompte et financement",
"Références Divalto",
"Rechercher…",
"Commande",
"Vendeur",
"Démo",
"Stock",
"Code client Divalto :",
"Numéro cde Divalto :",
"Réf cde revendeur :",
"Code client Divalto",
"Code client Divalto enregistré",
"N° Divalto",
"Réf. revendeur",
"Référence enregistrée",
"Recadrer et redresser la photo",
"Redresser",
"Zoom",
"A4 portrait",
"A4 paysage",
"Photo entière",
"Garder la photo telle quelle",
"Valider la photo",
"Ajouter un PDF",
"Prenez en photo chaque page du bon de commande papier signé par le client, ou ajoutez la commande signée en PDF.",
"Hors secteur : validation manager",
"Supprimer la fiche",
"Supprimer définitivement cette fiche client ?",
"Fiche client supprimée",
"Aucun devis ne correspond aux filtres",
"Du",
"au",
"Remise sur les frais",
"Offrir",
"Frais d'immatriculation offerts",
"Frais d'immatriculation après remise",
"dont frais d'immatriculation HT (remise déduite de votre marge)",
"Acompte reçu",
"Financement : à choisir",
"Financement OK",
"Pas de financement",
"Financement en étude",
"Saisir pour le compte de",
"Moi-même",
"Tarifs, marge et secteur de ce revendeur ; le devis sera à son nom.",
"Saisi par",
"Provenance du contact",
"Le nom et le prénom du client sont obligatoires.",
"Supprimer définitivement cette fiche client ? Ses devis non signés seront conservés, sans fiche client.",
"nom",
"prénom",
"adresse",
"ville",
"Champs obligatoires manquants",
"Particulier",
"Catégories d'options :",
"Catégorie",
"SIRET",
"Annulée et remplacée par",
"Suspendue : modification en cours",
"Annule et remplace",
"Annule et remplace la commande",
"Modifier la commande (annule et remplace)",
"Modification de la commande",
"Adresse au format invalide",
"Refusée par le service d'envoi",
"Renvoi Brevo en cours",
"Renvoi Brevo : résultat inconnu",
"Échec du renvoi Brevo",
"Renvoyé via Brevo (accepté)",
"Corriger l'adresse",
"Réessayer via Brevo",
"L'adresse n'est pas forcément incorrecte : le service d'envoi l'a refusée avant l'envoi.",
"Réinitialiser les filtres",
"Renseigné",
"Manquant",
"Mois de signature",
"Acompte non reçu",
"Sans objet",
"Stock / démo",
"Commande avec financement : gérée par le manager",
"Transmise à Corinne",
"Pas encore transmise à Corinne",
"Hors secteur : envoyée seulement à contact@fautras.com",
"Véhicule de stock : envoyée seulement à contact@fautras.com",
"Transmis à Corinne",
"Hors secteur (non transmis)",
"Pas encore transmis",

"Commande transmise à Corinne Golfier",
"Envoi à Corinne impossible pour le moment : il sera retenté à la prochaine modification.",
"Scan",
"10 fichiers maximum par commande",
"Commande papier enregistrée, mais l'e-mail n'est pas parti : renvoyez-la avec le bouton e-mail de la ligne.",
"Commande papier enregistrée, mais l'e-mail n'est pas parti : renvoyez-la depuis Mes devis avec le bouton e-mail.",
"Traduction enregistrée",
"Traductions",
"Traduire",
"Corriger traduction",
"Transport usine → revendeur inclus dans le prix public (pas nécessairement dans le prix revendeur)",
"Transport usine → revendeur inclus dans le prix public · prix revendeur hors transport",
"Trop de tentatives. Réessayez dans 15 minutes.",
"Très bon état",
"Très mauvais état",
"Type",
"Type :",
"Type de plancher",
"Type panneaux de côté",
"Tél.",
"Télécharger",
"Télécharger le PDF",
"Téléphone",
"USA",
"Van chevaux",
"Vans chevaux & Fourgons Pro & Sport. Configurez, chiffrez et envoyez vos devis en quelques clics.",
"Vendu",
"Veuillez choisir le lieu de livraison.",
"Veuillez faire signer le client (Bon pour accord) avant de passer commande.",
"Veuillez renseigner une description pour chaque option spéciale ayant un libellé.",
"Vide = délai confirmé à réception de commande par Fautras",
"Ville",
"Virement",
"Visible par tous les revendeurs",
"Voici le PDF que le client peut télécharger depuis l'e-mail envoyé à",
"Voir la commande signée",
"Voir le devis",
"Voir le récapitulatif",
"Voir le récapitulatif du devis",
"Voir les financements",
"Votre configuration",
"Vous pouvez joindre un RIB (PDF ou image) \\u00e0 l'e-mail.",
"Vous pouvez télécharger ou imprimer votre commande.",
"Véhicule tracteur en",
"Véhicules à la vente",
"Occasion en stock sans prix : ajoutez le prix de vente pour imprimer l'affiche.",
"Prix à définir",
"Renseignez le prix de vente pour faire un devis",
"Prix à définir : renseignez le prix de vente de l'occasion avant de faire le devis.",
"Option spéciale",

"remise",
"Pièce jointe",
"CGV lues et acceptées par le client le",
"Devis",
"Lisez le devis complet, puis signez en bas de page.",

"Prix de vente TTC",
"Prix de vente enregistré",
"OK",



"ajouter au moins une photo du véhicule repris est recommandé pour valider l'estimation.",
"an restant",
"annee",
"ans restants",
"attelage",
"bande du haut",
"broches",
"carrosserie",
"choix disponible",
"choix disponibles",
"comme les bandes",
"configurateur",
"cours BCE du",
"dont TVA",
"dont net a payer HT",
"electricite",
"freins",
"gardeboue",
"haut et bas identiques",
"hors transport",
"immat",
"l'année",
"la marque",
"le nombre de places",
"le prix de reprise TTC",
"les tarifs affichés sont recalculés.",
"modele",
"mois",
"non comptées",
"option(s)",
"options non disponibles sur",
"ouvertures",
"panneaux",
"panneaux_type",
"par",
"par défaut",
"photo(s) — voir liens ci-dessous",
"places",
"plancher",
"plancher_type",
"pneus",
"promo incluse",
"ptac",
"puis cliquez sur « Mettre en stock et créer une affiche prix ».",
"reprises",
"revendeur(s)",
"son adresse",
"structure",
"tapis",
"transport inclus jusqu'au point de vente",
"van",
"versions",
"versions disponibles.",
"veuillez renseigner",
"vous@exemple.com",
"À changer",
"À partir de",
"À remplacer",
"À remplacer/réparer",
"À réparer",
"À réparer/remplacer",
"À réviser",
"Écart TTC (comparé − actuel)",
"Échec de l'enregistrement",
"Échec de l'envoi des photos",
"Échec de l'envoi du fichier",
"Électricité fonctionne",
"Étape 1 / 2",
"État carrosserie",
"État des panneaux de côté",
"État du plancher",
"Événement ou lieu de stockage (titre de l'affiche)",
"Êtes-vous sûr de vouloir supprimer",
"+ Créer un événement…",
"Adresse email du client corrigée",
"Adresse refusée par le service d'envoi",
"Affichage indicatif en euros : le devis et le PDF restent en",
"Autre (une seule fois)…",
"Carte grise",
"Choisir le lieu de stockage",
"Choisissez d'abord le type de véhicule pour remplir le descriptif.",
"Continuer vers la signature",
"Copier le lien",
"Copier le lien vers le devis",
"Email refusé : à vérifier",
"Emails à vérifier",
"Enregistrer comme mon RIB par défaut",
"Enregistrer l'adresse corrigée",
"Ex. Equita Lyon 2026",
"Frais administratifs",
"Frais d'immatriculation",
"Frais de plaque",
"Impossible de copier le lien",
"L'événement sera ajouté à la liste pour tous les vendeurs.",
"Lien du devis copié : collez-le dans votre message au client",
"Lieu de stockage",
"Mon RIB enregistré",
"Origine du véhicule enregistrée. Copier le lien de signature du devis ?",
"Préciser le lieu",
"Reprise d'un devis non signé : la commande du neuf n'est pas encore signée.",
"Serveur injoignable, vérifiez votre connexion internet et réessayez.",
"TOTAL A PAYER TTC",
"Total à payer TTC",
"Une erreur est survenue. Veuillez réessayer.",
"Vous pouvez joindre un RIB (PDF ou image) à l'e-mail.",
"dont frais d'immatriculation HT (identiques client)",
"immat.",
"sans TVA",
"Événement ajouté à la liste",

];
